import React, {useEffect, useState} from "react";
import InputRange from 'react-input-range';
import "../../src/assets/css/multirange-slider.scss";
import 'react-input-range/lib/css/index.css';
import {isMobileOnly} from "react-device-detect";
import PropTypes from "prop-types";

const ShopMultiRangeWeighSlider = ({ sortedHighPrice, sortedLowPrice, currentQuery, setCurrentQuery, isHome, setLoadingProducts }) => {
    const [minValue, set_minValue] = useState(0);
    const [maxValue, set_maxValue] = useState(1);
    const [selectedPriceValue, setSelectedPriceValue] = useState({min: sortedLowPrice, max: sortedHighPrice});
    const [hide, setHide] = useState(false)
    const [display, setDisplay] = useState('none')
    const [isSmallScreen, setSmallScreen] = useState(false);
    const [selectedPriceFinalValue, setSelectedPriceFinalValue] = useState({min: sortedLowPrice, max: sortedHighPrice});

    useEffect(() => {
        const matchResult = window.matchMedia("(max-width: 992px)");
        if (matchResult.matches) {
            setSmallScreen(true)
        }
    }, [])

    useEffect(() => {
        set_maxValue(sortedHighPrice)
        set_minValue(sortedLowPrice)
        setSelectedPriceValue({min: currentQuery.lowWeigh ? currentQuery.lowWeigh : sortedLowPrice, max: currentQuery.highWeigh ? currentQuery.highWeigh : sortedHighPrice})
    }, [sortedHighPrice, sortedLowPrice, currentQuery])

    useEffect(() => {
        setCurrentQuery({ ...currentQuery, lowWeigh: selectedPriceFinalValue.min, highWeigh: selectedPriceFinalValue.max});
    }, [selectedPriceFinalValue])

    window.addEventListener("resize", function() {
        if (window.matchMedia("(min-width: 992px)").matches) {
            setSmallScreen(true)
        }
    })

    useEffect(() => {
        if (hide) {
            setDisplay('none')
        } else {
            setDisplay('block')
        }
    }, [hide])

    useEffect(() => {
        if (isMobileOnly || isSmallScreen){
            setHide(false)
        }
    }, [isSmallScreen])

    return (
        <div className="sidebar-widget mt-10 mb-20">
            <div>
            <h4 className="pro-sidebar-title">{isHome ? "Quelle plage de poids ? (facultatif)" : "Poids :"} &nbsp;
                </h4>
                <div className="sidebar-widget-tag-gender mt-20" style={{display: display}}>
                    { sortedHighPrice > 1 && maxValue > 1 && minValue >= 0 ?
                        <InputRange
                            draggableTrack
                            maxValue={sortedHighPrice}
                            minValue={sortedLowPrice}
                            step={10}
                            formatLabel={value => `${value} g`}
                            onChange={value => setSelectedPriceValue(value)}
                            onChangeComplete={value => {
                                setLoadingProducts(true)
                                setSelectedPriceFinalValue(value)
                                setSelectedPriceValue(value)}
                            }
                            value={selectedPriceValue}/>
                        :
                        null
                    }

                </div>
            </div>
        </div>
    );
};

ShopMultiRangeWeighSlider.propTypes = {
    sortedHighPrice: PropTypes.any,
    sortedLowPrice: PropTypes.any,
    getSortParams: PropTypes.func
};

export default ShopMultiRangeWeighSlider;